export default __webpack_public_path__ + "static/media/NewBadge.9f558ccf.svg";